const ACTION_TYPES = {
  ON_FIELD_CHANGE: 'ON_FIELD_CHANGE',
  ADD_JIRA_TO_TEST_CASE_SUBMIT: 'ADD_JIRA_TO_TEST_CASE_SUBMIT',
  ADD_JIRA_TO_TEST_CASE_CANCEL: 'ADD_JIRA_TO_TEST_CASE_CANCEL',
  ADD_JIRA_TO_TEST_CASE_CLICK: 'ADD_JIRA_TO_TEST_CASE_CLICK'
};

export default ACTION_TYPES;
